const PRODUCTION_ORIGIN = "https://lessonlaunchpad.com";
const STAGING_ORIGIN = "https://www.stage.lessonlaunchpad.com";

const isLocalhostHostname = (hostname = "") =>
  hostname === "localhost" || hostname === "127.0.0.1";

const isLocalhostRedirectUri = (uri = "") =>
  /\/\/(localhost|127\.0\.0\.1)(?::\d+)?(?:\/|$)/i.test(String(uri));

const normalizeCallbackPath = (callbackPath = "") => {
  const trimmed = String(callbackPath || "").trim();
  if (!trimmed) {
    return "/";
  }
  return trimmed.startsWith("/") ? trimmed : `/${trimmed}`;
};

/**
 * Resolve an OAuth redirect URI for Lesson Launchpad hosts.
 * Known production/stage/local hosts win over a baked env value so a bad
 * `.env.local` cannot send live teachers to 127.0.0.1.
 */
export function getOAuthRedirectUri(callbackPath, { envUri, location } = {}) {
  const path = normalizeCallbackPath(callbackPath);
  const resolvedLocation =
    location
    || (typeof window !== "undefined" ? window.location : null);

  if (resolvedLocation?.hostname) {
    const { hostname, port } = resolvedLocation;

    if (hostname === "lessonlaunchpad.com" || hostname === "www.lessonlaunchpad.com") {
      return `${PRODUCTION_ORIGIN}${path}`;
    }

    if (
      hostname === "stage.lessonlaunchpad.com"
      || hostname === "www.stage.lessonlaunchpad.com"
    ) {
      return `${STAGING_ORIGIN}${path}`;
    }

    if (isLocalhostHostname(hostname)) {
      const devPort = port || "3000";
      return `http://127.0.0.1:${devPort}${path}`;
    }
  }

  const configured = typeof envUri === "string" ? envUri.trim() : "";
  if (configured && !isLocalhostRedirectUri(configured)) {
    return configured;
  }

  return `${PRODUCTION_ORIGIN}${path}`;
}

export function getSpotifyRedirectUri(options = {}) {
  return getOAuthRedirectUri("/spotify-callback", {
    envUri: process.env.REACT_APP_SPOTIFY_REDIRECT_URI,
    ...options,
  });
}

export function getCanvaRedirectUri(options = {}) {
  return getOAuthRedirectUri("/canva-callback", {
    envUri: process.env.REACT_APP_CANVA_REDIRECT_URI,
    ...options,
  });
}

export function getGmailOAuthRedirectUri(options = {}) {
  return getOAuthRedirectUri("/gmail-callback", {
    envUri: process.env.REACT_APP_GMAIL_REDIRECT_URI,
    ...options,
  });
}

export function getGoogleDriveOAuthRedirectUri(options = {}) {
  return getOAuthRedirectUri("/google-drive-callback", {
    envUri: process.env.REACT_APP_GOOGLE_DRIVE_REDIRECT_URI,
    ...options,
  });
}
